import { StoreType } from '@tock/shared/utils/connect';

export const lockSelector = (state: StoreType) => state.lock;
